import { render, staticRenderFns } from "./TileViewer.vue?vue&type=template&id=0815d7e7&scoped=true"
import script from "./TileViewer.vue?vue&type=script&lang=js"
export * from "./TileViewer.vue?vue&type=script&lang=js"
import style0 from "./TileViewer.vue?vue&type=style&index=0&id=0815d7e7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815d7e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0815d7e7')) {
      api.createRecord('0815d7e7', component.options)
    } else {
      api.reload('0815d7e7', component.options)
    }
    module.hot.accept("./TileViewer.vue?vue&type=template&id=0815d7e7&scoped=true", function () {
      api.rerender('0815d7e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/TileViewer.vue"
export default component.exports